/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { jsonWebKeySetsListKeys } from "../funcs/jsonWebKeySetsListKeys.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListJSONWebKeysResult } from "../models/components/listjsonwebkeysresult.js";
import {
  ListJsonWebKeysRequest,
  ListJsonWebKeysSecurity,
} from "../models/operations/listjsonwebkeys.js";
import { unwrapAsync } from "../types/fp.js";
export type ListJsonWebKeysQueryData = ListJSONWebKeysResult;

export function prefetchListJsonWebKeys(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListJsonWebKeysRequest,
  security?: ListJsonWebKeysSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListJsonWebKeysQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListJsonWebKeysQuery(
  client$: GramCore,
  request: ListJsonWebKeysRequest,
  security?: ListJsonWebKeysSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListJsonWebKeysQueryData>;
} {
  return {
    queryKey: queryKeyListJsonWebKeys({
      setId: request.setId,
      includeRevoked: request.includeRevoked,
      gramSession: request.gramSession,
    }),
    queryFn: async function listJsonWebKeysQueryFn(
      ctx,
    ): Promise<ListJsonWebKeysQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(jsonWebKeySetsListKeys(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListJsonWebKeys(
  parameters: {
    setId: string;
    includeRevoked?: boolean | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "jsonWebKeySets", "listKeys", parameters];
}
